import { combineReducers, configureStore  } from '@reduxjs/toolkit'
import { FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from "redux-persist"
import storage from 'redux-persist/lib/storage';

import { authReducer, modeReducer, adminReducer, contactReducer, postReducer } from './';

import { persistReducer } from "redux-persist"

const persistConfig    = { key: "root", storage, version: 1 }

const persistedReducer = persistReducer(persistConfig, combineReducers({
    authList:          authReducer,
    modeList:          modeReducer,
    adminList:         adminReducer,
    postList:          postReducer,
    contactList:       contactReducer,
}));

const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({
        thunk: true,
        serializableCheck: {
            ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER]
        }
    })
})
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export default store;